import { render, staticRenderFns } from "./SelectBoxV2.vue?vue&type=template&id=d8c83226&scoped=true"
import script from "./SelectBoxV2.vue?vue&type=script&lang=ts"
export * from "./SelectBoxV2.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxV2.vue?vue&type=style&index=0&id=d8c83226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c83226",
  null
  
)

export default component.exports